var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGroundwaterGround(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 398.424,
    height: 133.401
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 305"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 69",
    d: "M392.356.815c-3.852-.365-7.394 2.962-11.224 2.413-2.494-.357-4.629-2.327-7.148-2.29-2.48.037-4.616 2.028-7.1 2.053-2.415.025-4.532-1.817-6.946-1.879-2.8-.071-5.251 2.259-8.051 2.149-2.57-.1-4.646-2.219-7.176-2.681-3.973-.726-7.642 2.336-11.238 4.172-3.176-.325-5.62-3.511-8.812-3.405-2.831.094-4.924 2.745-7.68 3.392-4.281 1.005-8.37-3.05-12.745-2.581-2.148.23-4.013 1.524-6.073 2.165a10.31 10.31 0 01-6.722-.233c-2.6-1.011-5.273-3.121-7.851-2.053a19.951 19.951 0 00-2.348 1.507c-2.206 1.3-5.083.892-7.382-.239-1.845-.907-3.839-2.285-5.768-1.568-1.717.639-2.675 2.784-4.5 2.987-2.415.268-3.754-2.985-6.115-3.555-3.065-.74-5.544 3.32-8.686 3.043-1.849-.163-3.236-1.8-5.035-2.246a4.913 4.913 0 00-5.269 2.537l-78.6-.413 79.085.413-78.832-1.448c-3.38.058-3.47-1.893-6.311-2.162-3.852-.365-7.395 2.962-11.225 2.413-2.494-.358-4.628-2.327-7.147-2.29-2.48.037-4.616 2.027-7.1 2.053-2.415.025-4.532-1.818-6.946-1.879-2.8-.072-5.251 2.259-8.051 2.149-2.569-.1-4.646-2.22-7.175-2.681-3.973-.726-7.642 2.336-11.238 4.172-3.176-.325-5.621-3.512-8.812-3.405-2.831.094-4.924 2.745-7.679 3.392-4.281 1.005-8.37-3.05-12.745-2.581-2.147.23-4.013 1.524-6.074 2.164a10.3 10.3 0 01-6.721-.233c-2.6-1.01-5.273-3.121-7.852-2.053a20.235 20.235 0 00-2.347 1.507c-2.206 1.3-5.083.892-7.382-.238-1.845-.907-3.839-2.285-5.768-1.568-1.717.638-2.676 2.784-4.5 2.986-2.415.268-3.753-2.985-6.114-3.555-3.065-.74-5.544 3.321-8.686 3.044-1.849-.164-3.237-1.8-5.035-2.246A4.211 4.211 0 00.451 4.481v128.92h159.447l79.085-.158v.079h159.432V2.955c-3.381.06-3.218-1.872-6.059-2.14z",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 70",
    d: "M7.869 15.188a2.429 2.429 0 01.581-.4 5.3 5.3 0 012.665-.387 6.6 6.6 0 012.4.483c1.648.748 2.179 2.659 2.283 4.326.115 1.842-8.51 2.86-8.721-1.273a3.387 3.387 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 71",
    d: "M29.1 14.685a1.193 1.193 0 01-.042-.351 2.651 2.651 0 01.452-1.268 3.308 3.308 0 01.775-.948 2.392 2.392 0 012.446 0c.84.38-.727 4.429-2.6 3.557a1.7 1.7 0 01-1.031-.99z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 72",
    d: "M25.494 44.695a2.4 2.4 0 01.58-.4 5.3 5.3 0 012.665-.387 6.6 6.6 0 012.4.483c1.648.749 2.179 2.659 2.283 4.326.116 1.842-8.51 2.859-8.721-1.273a3.385 3.385 0 01.793-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 73",
    d: "M52.206 26.389a2.407 2.407 0 01.581-.4 5.3 5.3 0 012.664-.387 6.6 6.6 0 012.4.483c1.648.749 2.179 2.659 2.283 4.326.116 1.842-8.51 2.859-8.72-1.273a3.387 3.387 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 74",
    d: "M71.87 9.889a2.43 2.43 0 01.581-.4 5.3 5.3 0 012.664-.387 6.578 6.578 0 012.4.483c1.648.748 2.179 2.658 2.283 4.325.116 1.842-8.509 2.86-8.72-1.273a3.387 3.387 0 01.792-2.748z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75",
    d: "M83.249 31.832a2.424 2.424 0 01.581-.4 5.3 5.3 0 012.665-.387 6.6 6.6 0 012.4.483c1.648.748 2.179 2.659 2.283 4.326.115 1.842-8.51 2.86-8.721-1.273a3.387 3.387 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 76",
    d: "M108.561 10.184a14.057 14.057 0 015.652-.457c2.4.461 2.68 3.745 2.581 5.854-.19 4.088-8.569 2.206-11.1 1.5-1.964-.544-.915-3.745-.146-4.863a5.009 5.009 0 013.013-2.034z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 77",
    d: "M126.009 28.616a1.81 1.81 0 01.4-.4 2.687 2.687 0 011.85-.387 3.416 3.416 0 011.666.483c1.144.749 1.513 2.659 1.585 4.326.08 1.842-5.908 2.859-6.055-1.273a4.478 4.478 0 01.554-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 78",
    d: "M134.247 9.889a2.432 2.432 0 01.581-.4 5.3 5.3 0 012.664-.387 6.582 6.582 0 012.4.483c1.648.748 2.179 2.658 2.283 4.325.115 1.842-8.51 2.86-8.72-1.273a3.387 3.387 0 01.792-2.748z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 79",
    d: "M.465 4.481a4.211 4.211 0 014.781-2.437c1.8.45 3.187 2.082 5.035 2.246 3.143.277 5.622-3.784 8.686-3.044 2.36.571 3.7 3.823 6.114 3.555 1.824-.2 2.782-2.348 4.5-2.986 1.929-.717 3.923.661 5.768 1.568 2.3 1.131 5.176 1.537 7.382.238a20.206 20.206 0 012.347-1.507c2.578-1.067 5.25 1.043 7.852 2.053a10.3 10.3 0 006.721.233c2.061-.64 3.926-1.934 6.074-2.164 4.374-.469 8.464 3.586 12.745 2.581 2.755-.647 4.848-3.3 7.679-3.392 3.191-.107 5.636 3.08 8.812 3.405 3.6-1.836 7.265-4.9 11.237-4.172 2.529.461 4.607 2.581 7.176 2.681 2.8.11 5.251-2.221 8.051-2.149 2.414.061 4.531 1.9 6.946 1.879 2.48-.026 4.615-2.016 7.1-2.053 2.519-.038 4.653 1.932 7.147 2.29 3.83.549 7.373-2.778 11.225-2.413 2.841.269 2.931 2.22 6.311 2.162",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 80",
    d: "M147.855 94.885a2.428 2.428 0 01.581-.4 5.308 5.308 0 012.664-.387 6.611 6.611 0 012.4.483c1.75.8 3.418 4.3 1.185 5.465-2.12 1.105-7.461.731-7.621-2.412a3.387 3.387 0 01.791-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 81",
    d: "M147.855 63.831a2.428 2.428 0 01.581-.4 5.308 5.308 0 012.664-.387 6.611 6.611 0 012.4.483c1.648.749 2.179 2.659 2.283 4.326.116 1.842-8.509 2.859-8.72-1.273a3.387 3.387 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 82",
    d: "M158.55 118.719a2.426 2.426 0 01.58-.4 5.312 5.312 0 012.665-.387 6.619 6.619 0 012.4.483c1.648.749 2.179 2.659 2.283 4.326.116 1.841-8.51 2.859-8.72-1.274a3.388 3.388 0 01.792-2.748z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 83",
    d: "M191.343 98.111a14.054 14.054 0 014.118 3.9c1.265 2.1-.993 4.5-2.628 5.833-3.168 2.591-7.369-4.9-8.54-7.249-.908-1.824 2.174-3.184 3.519-3.36a5.009 5.009 0 013.531.876z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 84",
    d: "M221.04 116.829a1.824 1.824 0 01.4-.4 2.679 2.679 0 011.85-.387 3.408 3.408 0 011.667.483c1.144.749 1.512 2.659 1.585 4.326.08 1.842-5.908 2.859-6.055-1.273a4.475 4.475 0 01.553-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 85",
    d: "M6.169 102.561a2.417 2.417 0 01.58-.4 5.3 5.3 0 012.665-.387 6.6 6.6 0 012.4.483c1.648.749 2.179 2.659 2.283 4.326.116 1.842-8.51 2.859-8.72-1.273a3.388 3.388 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 86",
    d: "M30.2 93.279a2.4 2.4 0 01.581-.4 5.3 5.3 0 012.664-.388 6.614 6.614 0 012.4.483c1.648.749 2.179 2.659 2.283 4.326.116 1.842-8.509 2.859-8.72-1.273a3.388 3.388 0 01.792-2.748z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 87",
    d: "M30.2 117.112a2.4 2.4 0 01.581-.4 5.3 5.3 0 012.664-.387 6.6 6.6 0 012.4.483c1.648.749 2.179 2.659 2.283 4.326.116 1.842-8.509 2.859-8.72-1.273a3.39 3.39 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 88",
    d: "M62.885 102.02a14.047 14.047 0 012.331 5.168c.376 2.419-2.624 3.784-4.643 4.4-3.914 1.2-4.961-7.327-5.153-9.946-.149-2.033 3.22-2.122 4.531-1.775a5.011 5.011 0 012.934 2.153z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 89",
    d: "M84.337 112.008a1.845 1.845 0 01.4-.4 2.685 2.685 0 011.85-.387 3.4 3.4 0 011.666.483c1.144.748 1.513 2.658 1.585 4.326.08 1.842-5.908 2.859-6.055-1.273a4.483 4.483 0 01.554-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 90",
    d: "M115.261 112.008a2.426 2.426 0 01.581-.4 5.3 5.3 0 012.665-.387 6.586 6.586 0 012.4.483c1.647.748 2.179 2.658 2.283 4.326.115 1.842-8.51 2.859-8.721-1.273a3.387 3.387 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91",
    d: "M17.257 71.508a2.435 2.435 0 01.252.66 5.3 5.3 0 01-.26 2.68 6.584 6.584 0 01-1.042 2.216c-1.12 1.422-3.1 1.482-4.745 1.186-1.817-.328-.748-8.946 3.315-8.166a3.389 3.389 0 012.48 1.424z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 92",
    d: "M48.585 62.824a14.042 14.042 0 015.651-.456c2.405.46 2.68 3.744 2.582 5.854-.19 4.088-8.569 2.206-11.1 1.5-1.964-.544-.915-3.745-.146-4.863a5.01 5.01 0 013.013-2.035z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 93",
    d: "M78.386 78.259a1.826 1.826 0 01.4-.4 2.686 2.686 0 011.849-.387 3.417 3.417 0 011.666.484c1.144.749 1.513 2.659 1.585 4.326.08 1.842-5.908 2.859-6.055-1.273a4.479 4.479 0 01.555-2.75z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 94",
    d: "M107.443 47.909a2.411 2.411 0 01.58-.4 5.3 5.3 0 012.665-.387 6.6 6.6 0 012.4.483c1.648.749 2.179 2.659 2.283 4.326.116 1.842-8.51 2.859-8.72-1.273a3.389 3.389 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 95",
    d: "M119.628 70.313a2.426 2.426 0 01.581-.4 5.3 5.3 0 012.664-.387 6.594 6.594 0 012.4.483c1.648.748 2.179 2.659 2.283 4.326.116 1.842-8.509 2.86-8.72-1.273a3.387 3.387 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 96",
    d: "M83.114 61.467a16.758 16.758 0 01-1.106-1.185c-.787-.923-1.953-2.053-2.181-3.284a1.6 1.6 0 01.975-1.861 2.132 2.132 0 011.57.418 11.969 11.969 0 014.924 5.942 1.81 1.81 0 01.157.764c-.082 1.054-1.66 1.209-2.551.639a11.54 11.54 0 01-1.788-1.433z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 97",
    d: "M118.992 96.54c-.436.318-.891.612-1.358.887-1.044.617-2.357 1.572-3.609 1.585a1.6 1.6 0 01-1.666-1.28 2.129 2.129 0 01.681-1.475 11.964 11.964 0 016.7-3.832 1.813 1.813 0 01.779-.024c1.025.262.906 1.843.192 2.623a11.5 11.5 0 01-1.719 1.516z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 98",
    d: "M233.746 96.646a16.746 16.746 0 01-.431 1.563c-.373 1.153-.725 2.739-1.655 3.578a1.6 1.6 0 01-2.1.143 2.133 2.133 0 01-.467-1.556 11.965 11.965 0 012.484-7.307 1.8 1.8 0 01.568-.535c.941-.482 1.9.781 1.88 1.839a11.533 11.533 0 01-.279 2.275z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 99",
    d: "M208.861 67.047a2.431 2.431 0 01.581-.4 5.308 5.308 0 012.664-.387 6.614 6.614 0 012.4.483c1.75.8 3.418 4.3 1.185 5.465-2.12 1.105-7.461.731-7.621-2.412a3.387 3.387 0 01.791-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10,
    strokeWidth: 1.188
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 101",
    d: "M246.386 15.11a2.421 2.421 0 01.58-.4 5.313 5.313 0 012.665-.387 6.615 6.615 0 012.4.483c1.648.749 2.179 2.659 2.283 4.326.116 1.842-8.51 2.859-8.72-1.273a3.388 3.388 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 102",
    d: "M267.615 14.606a1.21 1.21 0 01-.042-.351 2.66 2.66 0 01.452-1.268 3.317 3.317 0 01.775-.948 2.39 2.39 0 012.446 0c.841.38-.726 4.429-2.6 3.556a1.693 1.693 0 01-1.031-.989z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 103",
    d: "M264.012 44.617a2.426 2.426 0 01.581-.4 5.3 5.3 0 012.664-.387 6.6 6.6 0 012.4.483c1.648.748 2.179 2.659 2.283 4.326.115 1.842-8.509 2.859-8.72-1.273a3.387 3.387 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 104",
    d: "M290.723 26.309a2.431 2.431 0 01.581-.4 5.3 5.3 0 012.664-.387 6.594 6.594 0 012.4.483c1.648.748 2.179 2.659 2.283 4.325.116 1.842-8.509 2.86-8.72-1.272a3.388 3.388 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105",
    d: "M310.387 9.809a2.429 2.429 0 01.581-.4 5.311 5.311 0 012.665-.387 6.617 6.617 0 012.4.483c1.648.749 2.179 2.659 2.283 4.326.115 1.842-8.51 2.859-8.721-1.273a3.387 3.387 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 106",
    d: "M321.767 31.753a2.4 2.4 0 01.581-.4 5.3 5.3 0 012.664-.388 6.615 6.615 0 012.4.483c1.648.749 2.179 2.659 2.283 4.326.116 1.842-8.509 2.859-8.72-1.273a3.388 3.388 0 01.792-2.748z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 107",
    d: "M347.079 10.106a14.03 14.03 0 015.651-.457c2.4.461 2.68 3.745 2.582 5.854-.191 4.088-8.569 2.206-11.1 1.505-1.964-.545-.914-3.746-.146-4.864a5.008 5.008 0 013.013-2.038z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108",
    d: "M364.526 28.537a1.805 1.805 0 01.4-.4 2.683 2.683 0 011.85-.387 3.412 3.412 0 011.667.483c1.144.749 1.512 2.659 1.584 4.326.08 1.842-5.908 2.859-6.054-1.273a4.475 4.475 0 01.553-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 109",
    d: "M372.764 9.809a2.429 2.429 0 01.581-.4 5.308 5.308 0 012.664-.387 6.613 6.613 0 012.4.483c1.648.749 2.179 2.659 2.283 4.326.115 1.842-8.509 2.859-8.72-1.273a3.387 3.387 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 110",
    d: "M238.983 4.403a4.211 4.211 0 014.781-2.437c1.8.45 3.187 2.083 5.035 2.246 3.143.277 5.622-3.784 8.686-3.043 2.36.57 3.7 3.823 6.115 3.555 1.824-.2 2.782-2.348 4.5-2.987 1.929-.717 3.923.661 5.768 1.568 2.3 1.131 5.176 1.537 7.382.239a19.951 19.951 0 012.348-1.507c2.577-1.068 5.25 1.042 7.851 2.053a10.31 10.31 0 006.722.233c2.06-.641 3.925-1.934 6.073-2.165 4.375-.469 8.464 3.586 12.745 2.581 2.756-.647 4.849-3.3 7.68-3.392 3.192-.106 5.636 3.08 8.812 3.405 3.6-1.836 7.265-4.9 11.238-4.172 2.529.462 4.606 2.581 7.176 2.681 2.8.11 5.25-2.22 8.05-2.149 2.414.062 4.531 1.9 6.946 1.879 2.48-.025 4.615-2.016 7.1-2.053 2.519-.038 4.653 1.933 7.148 2.29 3.83.549 7.372-2.778 11.224-2.413 2.841.269 2.678 2.2 6.059 2.141",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 111",
    d: "M386.372 94.806a2.4 2.4 0 01.581-.4 5.3 5.3 0 012.665-.387 6.6 6.6 0 012.4.483c1.75.8 3.418 4.3 1.185 5.466-2.121 1.1-7.461.73-7.622-2.412a3.389 3.389 0 01.791-2.75z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 112",
    d: "M386.372 63.752a2.4 2.4 0 01.581-.4 5.3 5.3 0 012.665-.387 6.6 6.6 0 012.4.483c1.648.749 2.179 2.659 2.283 4.326.115 1.842-8.509 2.859-8.721-1.273a3.389 3.389 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 113",
    d: "M244.686 102.483a2.425 2.425 0 01.581-.4 5.3 5.3 0 012.664-.387 6.582 6.582 0 012.4.483c1.648.748 2.179 2.658 2.283 4.326.116 1.842-8.509 2.86-8.72-1.272a3.387 3.387 0 01.792-2.75z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 114",
    d: "M268.717 93.2a2.425 2.425 0 01.581-.4 5.3 5.3 0 012.664-.387 6.6 6.6 0 012.4.483c1.648.749 2.18 2.659 2.283 4.326.115 1.842-8.509 2.86-8.72-1.273a3.387 3.387 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 115",
    d: "M268.717 117.035a2.427 2.427 0 01.581-.4 5.3 5.3 0 012.664-.387 6.6 6.6 0 012.4.483c1.648.748 2.18 2.659 2.283 4.325.115 1.842-8.509 2.86-8.72-1.273a3.387 3.387 0 01.792-2.748z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 116",
    d: "M301.402 101.94a14.04 14.04 0 012.331 5.168c.376 2.419-2.624 3.784-4.643 4.4-3.914 1.2-4.961-7.327-5.152-9.946-.149-2.032 3.219-2.122 4.53-1.774a5 5 0 012.934 2.152z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 117",
    d: "M322.856 111.928a1.83 1.83 0 01.4-.4 2.686 2.686 0 011.849-.387 3.415 3.415 0 011.667.483c1.145.748 1.513 2.659 1.585 4.325.08 1.842-5.908 2.86-6.055-1.273a4.478 4.478 0 01.554-2.748z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 118",
    d: "M353.779 111.928a2.421 2.421 0 01.58-.4 5.312 5.312 0 012.665-.387 6.614 6.614 0 012.4.483c1.648.748 2.179 2.659 2.283 4.325.116 1.842-8.509 2.86-8.72-1.273a3.387 3.387 0 01.792-2.748z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 119",
    d: "M255.774 71.429a2.425 2.425 0 01.251.66 5.3 5.3 0 01-.259 2.68 6.621 6.621 0 01-1.042 2.216c-1.121 1.422-3.1 1.482-4.746 1.186-1.817-.327-.748-8.946 3.315-8.165a3.386 3.386 0 012.481 1.423z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 120",
    d: "M287.103 62.745a14.034 14.034 0 015.651-.457c2.4.461 2.68 3.745 2.581 5.854-.19 4.088-8.569 2.206-11.1 1.505-1.963-.544-.915-3.746-.146-4.863a5.006 5.006 0 013.014-2.039z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 121",
    d: "M316.903 78.18a1.811 1.811 0 01.4-.4 2.682 2.682 0 011.85-.387 3.409 3.409 0 011.667.483c1.144.749 1.512 2.659 1.585 4.326.08 1.842-5.909 2.859-6.055-1.273a4.477 4.477 0 01.553-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 122",
    d: "M345.96 47.831a2.428 2.428 0 01.581-.4 5.3 5.3 0 012.664-.387 6.6 6.6 0 012.4.483c1.648.748 2.179 2.659 2.283 4.326.116 1.842-8.509 2.86-8.72-1.273a3.388 3.388 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 123",
    d: "M358.144 70.233a2.447 2.447 0 01.581-.4 5.311 5.311 0 012.665-.387 6.614 6.614 0 012.4.483c1.648.749 2.179 2.659 2.283 4.326.115 1.842-8.51 2.859-8.721-1.273a3.387 3.387 0 01.792-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 124",
    d: "M321.631 61.389a17.456 17.456 0 01-1.106-1.185c-.787-.923-1.953-2.053-2.181-3.284a1.6 1.6 0 01.975-1.861 2.139 2.139 0 011.571.418 11.963 11.963 0 014.924 5.943 1.8 1.8 0 01.158.763c-.082 1.054-1.661 1.209-2.551.639a11.576 11.576 0 01-1.79-1.433z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 125",
    d: "M357.509 96.461c-.436.318-.891.611-1.357.886-1.044.617-2.358 1.572-3.61 1.585a1.6 1.6 0 01-1.666-1.28 2.135 2.135 0 01.682-1.475 11.969 11.969 0 016.7-3.832 1.817 1.817 0 01.78-.024c1.024.262.906 1.843.191 2.623a11.55 11.55 0 01-1.72 1.517z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 126",
    d: "M172.32 41.4a2.421 2.421 0 01.58-.4 5.312 5.312 0 012.665-.387 6.6 6.6 0 012.4.483c1.648.748 2.179 2.659 2.283 4.326.116 1.842-8.51 2.86-8.721-1.273a3.384 3.384 0 01.793-2.749z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 127",
    d: "M230.461 35.921a14.039 14.039 0 014.118 3.9c1.265 2.1-.994 4.5-2.628 5.834-3.168 2.591-7.369-4.9-8.54-7.25-.908-1.824 2.174-3.184 3.519-3.36a5.006 5.006 0 013.531.876z",
    fill: "none",
    stroke: "#040405",
    strokeMiterlimit: 10
  }))));
}

export default __webpack_public_path__ + "985706f9081b4c9b6cbf5c06fecec013.svg";
export { SvgGroundwaterGround as ReactComponent };